<template>
    <div v-show="show" class="window-background dialog-window">
        <div class="window-title">
            <span>目錄</span>
            <img class="close-btn" src="../assets/common/btn_close_window.png" alt="" @click="switchDirectory">
        </div>
        <div class="window-content">
            <div class="tabs">
                <div class="tab-button" :class="{ 'now-selected': tab.pageTag == store.nowDirectoryTag }"
                    v-for="(tab, index) in directoryData" :key="index" @click="setNowTag(tab.pageTag)">{{
                        tab.pageName
                    }}
                </div>
            </div>
            <div class="content">
                <div class="directory-item" v-for="(item, index) in nowDirectory" :key="index"
                    @click="handleJumpPage(item.pageIndex)">
                    <div class="page-item-container">
                        <div class="page-item">
                            <div class="page-name">{{ item.pageName }}</div>
                            <div class="page-number">{{ nowBookContent[item.pageIndex].pageName }}</div>
                        </div>
                    </div>
                    <directory-item :directoryList="item.child" :directoryContent="nowBookContent"
                        @handleJumpPage="handleJumpPage" :layer="2"></directory-item>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BookData from '../js/book_data';
import DirectoryItem from './DirectoryItem.vue';
import { store } from "../store";
import { examStore } from '../js/store/examStore';
import { TURN_PAGE_TYPE } from '../js/book_define/turn_page_type';
import { BOOK_TYPE } from '../js/book_define/book_type';
import { pageTagStore } from '../js/store/pageTagStore';
import { settingStore } from '../js/store/settingStore';
import { quickDirectoryStore } from '../js/store/quickDirectoryStore';
import { VIEW_TYPE } from '../js/view_type';

export default {
    name: "Directory",
    data: function () {
        return {
            directoryData: [],
            directoryContent: {},
            show: false,
            store
        }
    },
    components: {
        DirectoryItem
    },
    watch: {
        watchToClose: {
            handler: function () {
                this.show = false;
            }
        }
    },
    methods: {
        async getDirectoryData() {
            let response = await fetch(BookData.Instance.getBookPath() + "pageConfig.json");
            const data = await response.json();
            this.directoryData = this.filterDirectory(data.directory);

            store.initPageContent(data.content);
            store.nowDirectoryTag = this.directoryData[0].pageTag;

            pageTagStore.setTags(data.tags);

            store.setDirectoryData(data.directory);

            this.setTurnPageType(data.turnPageDirection);

            if(store.onlyRead) {
                settingStore.isFixed = 0
            }else {
                settingStore.isFixed = data.isFixed == "normal" ? 0 : 1;
            }

            let fs = (g, p, pageTag) => {
                let result = [];

                g.child.forEach(v => {
                    if (v.child.length == 0) {
                        result.push(v);

                        store.directoryMap[pageTag] = store.directoryMap[pageTag] || [];

                        if (p.child) {
                            store.directoryMap[pageTag][v.pageIndex] = g.child.map(s => s.pageIndex);
                        }
                    } else {
                        result = [...result, ...fs(v, g, pageTag)];
                    }
                })

                return result;
            }

            console.log("map:", store.directoryMap);

            this.directoryData.forEach(value => {
                fs(value, this.directoryData, value.pageTag);
            })

            quickDirectoryStore.setData(this.directoryData);

            examStore.setExamData(data.directory);

            window.app.$refs.toolBar.setPageName();
            window.app.$refs.bookPage.init();
            window.pageControl.setBookData(data.content);
        },
        setNowTag(tag) {
            if(tag == BOOK_TYPE.RESOURCE) {
                window.pageControl.gotoPage(0, BOOK_TYPE.RESOURCE);
            }else {
                store.nowDirectoryTag = tag;
            }
        },
        switchDirectory() {
            this.show = !this.show
        },
        handleJumpPage(pageIndex) {
            console.log("jump page ", store.nowDirectoryTag);
            window.pageControl.gotoPage(pageIndex, store.nowDirectoryTag);

            
        },
        resultChild(obj) {
            if (obj.child) {
                return true;
            } else {
                return false;
            }
        },
        setTurnPageType(type) {
            if (type) {
                switch (type) {
                    case "right":
                        store.turnPageType = TURN_PAGE_TYPE.TURN_RIGHT;
                        break;
                    case "left":
                        store.turnPageType = TURN_PAGE_TYPE.TURN_LEFT;
                        break;
                }
            }
        },
        filterDirectory(jsonData) {
            // 網頁版、app版需不顯示周邊資源
            if (store.nowView == VIEW_TYPE.WEB || store.nowView == VIEW_TYPE.ANDROID || store.nowView == VIEW_TYPE.IOS) {
                return jsonData.filter((data) => data.pageTag != "resource");
            } else {
                return jsonData;
            }
        }
    },
    mounted: function () {
    },
    computed: {
        nowDirectory() {
            let data = this.directoryData.filter(item => {
                return item.pageTag == store.nowDirectoryTag;
            })
            if (data.length > 0) {
                return data[0].child;
            }
        },
        nowBookContent() {
            return this.store.pageContent[store.nowDirectoryTag];
        },
        watchToClose() {
            return `${store.nowBook}|${store.nowPage}|${store.singlePageIndex}`
        }
    },
    created: function () {
    }
}
</script>
<style src="../css/directory_item.css" scoped ></style>
<style scoped>
.dialog-window {
    position: absolute;
    z-index: var(--z-index-directory);
    margin: auto;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
}

.window-background {
    background: rgb(0, 89, 173);
    width: 60vw;
    min-width: 600px;
    max-width: 768px;
    height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border-radius: 0.5rem;
}

.window-content {
    background: white;
    width: calc(100% - 4rem);
    height: calc(100% - 5rem);
    left: 2rem;
    position: relative;
    display: flex;
    flex-direction: column;
}

.window-title {
    height: 3rem;
    width: 100%;
    font-size: 2rem;
    color: white;
    font-weight: bold;
}

.close-btn {
    position: absolute;
    right: 0.1rem;
    top: 0.1rem;
    width: 3rem;
}

.tabs {
    background: rgb(0, 89, 173);
    width: 100%;
    height: 2rem;
    display: flex;
    flex-direction: row;
    color: black;
    align-items: flex-end;
}

.content {
    height: 100%;
    overflow-y: auto;
    background-color: gray;
}

.content::-webkit-scrollbar {
    width: 20px;
}
.content::-webkit-scrollbar-track {
    background: #ffffff;
}

.content::-webkit-scrollbar-thumb {
    background: #d9d9d9;
}
.content::-webkit-scrollbar-thumb:hover {
    background: #808080;
}

.tab-button {
    user-select: none;
    width: 8rem;
    height: 2rem;
    line-height: 2rem;
    border: solid 1px #a5a5a5;
    background: #d9d9d9;
    border-radius: 0.3rem 0.3rem 0 0;

    font-weight: bold;
    font-size: 1.2rem;
}

.tab-button.now-selected {
    /* border: solid 1px #48a3a3; */
    background: #dbeef4;
}

.page-item {
    display: grid;
    width: calc(100% - 2em);
    grid-template-columns: 70% 30%;
    grid-column-start: 2;
    grid-column-end: 2;
    margin-left: 1em;
    align-items: center;
    /* border-bottom: 1px solid black; */
    /* color: black; */
}

.page-item:hover {
    color: black;
}

.page-number {
    font-size: 1.5rem;
    text-align: end;
    padding-right: 0.5rem;
}

.directory-item .page-item .page-name {
    font-weight: bold;
}
</style>